



























































































import {
  defineComponent,
  ref,
  Ref,
  onMounted,
  computed,
} from '@vue/composition-api';
import { SealInfo } from '@oare/types';
import sl from '@/serviceLocator';
import useQueryParam from '@/hooks/useQueryParam';

export default defineComponent({
  name: 'SealsView',
  components: {},
  props: {
    showRadioBtns: {
      type: Boolean,
      default: false,
    },
    hideImages: {
      type: Boolean,
      default: false,
    },
    textEpigraphyUuid: {
      type: String,
    },
    showConnectSeal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const seals: Ref<SealInfo[]> = ref([]);
    const sortedSeals: Ref<SealInfo[]> = ref([]);
    const search = useQueryParam('filter', '', true);
    const selectedSeal: Ref<SealInfo | null> = ref(null);
    const confirmConnectDialog: Ref<Boolean> = ref(false);

    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const store = sl.get('store');

    const canConnectSealImpression = computed(() =>
      store.hasPermission('ADD_SEAL_LINK')
    );

    const connectSeal = async () => {
      try {
        if (
          selectedSeal.value &&
          selectedSeal.value.uuid &&
          props.textEpigraphyUuid
        ) {
          await server.addSealLink({
            sealUuid: selectedSeal.value.uuid,
            textEpigraphyUuid: props.textEpigraphyUuid,
          });
          actions.showSnackbar(
            'Successfully connected seal to seal impression'
          );
        }
      } catch (err) {
        actions.showErrorSnackbar(
          'Unable to connect seal to seal impression',
          err as Error
        );
      } finally {
        emit('finish');
      }
    };

    const sortSeals = () => {
      sortedSeals.value = seals.value.sort((a, b) => {
        const aHasCS = a.name.includes('CS');
        const bHasCS = b.name.includes('CS');

        if (aHasCS && bHasCS) {
          const regex = /\d+$/;
          const aNum = Number(regex.exec(a.name));
          const bNum = Number(regex.exec(b.name));
          if (aNum && bNum) {
            return aNum - bNum;
          }
        }
        if (aHasCS && !bHasCS) {
          return -1;
        }
        if (!aHasCS && bHasCS) {
          return 1;
        }
        return a.name.localeCompare(b.name);
      });
    };

    const filteredSeals = computed(() =>
      sortedSeals.value.filter(seal =>
        seal.name.toLocaleLowerCase().includes(search.value.toLocaleLowerCase())
      )
    );

    onMounted(async () => {
      loading.value = true;
      try {
        seals.value = await server.getAllSeals();
        sortSeals();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading seals. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      filteredSeals,
      search,
      selectedSeal,
      canConnectSealImpression,
      confirmConnectDialog,
      connectSeal,
    };
  },
});
